var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 2.5H7.01725C7.79233 2.5 8.17987 2.5 8.28311 2.73344C8.38634 2.96688 8.12263 3.24693 7.59522 3.80702L4.56377 7.02632C4.03636 7.5864 3.77265 7.86645 3.87588 8.09989C3.97912 8.33333 4.36666 8.33333 5.14174 8.33333H8.33301",
    stroke: "#616874",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 17.5L5.08765 13.5877C5.41288 12.8626 5.57549 12.5 5.83301 12.5C6.09052 12.5 6.25313 12.8626 6.57837 13.5877L8.33301 17.5",
    stroke: "#616874",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5828 16.6673V3.33398M14.5828 16.6673C13.9993 16.6673 12.9091 15.0054 12.4995 14.584M14.5828 16.6673C15.1663 16.6673 16.2566 15.0054 16.6662 14.584",
    stroke: "#616874",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescending);
export default __webpack_public_path__ + "static/media/descending.ec3b2de68e56fbb842be843cc61d021b.svg";
export { ForwardRef as ReactComponent };